import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
//import { ToastrService } from 'ngx-toastr';
import { UserService } from '../shared/services/user.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  formModel ={
    id : null,
    token: null,
    password : null,
  }
    constructor(
      public service:UserService,
      private router : Router,
      //private toastr : ToastrService,
      private gnotify : GlobalNotification,
      private activeroute: ActivatedRoute) { }

    ngOnInit() {
      this.service.formModel.reset();

      console.log(this.activeroute.snapshot.queryParamMap.get('id'));

      this.formModel.id = this.activeroute.snapshot.queryParamMap.get('id');
      this.formModel.token = this.activeroute.snapshot.queryParamMap.get('token');
    }

    onSubmit(){

      console.log("onSubmit");
    this.formModel.password = this.service.formModel.value.Passwords.Password;

    this.service.resetPassword(this.formModel).subscribe(
      (res : any) => {
        if (res.succeeded) {
          ////this.toastr.success("The password changed!", "Reset password successfuly");
          this.gnotify.showSnackBar('Reset password', 'The password changed!', "success");
          this.router.navigateByUrl('/login');
        }
        else {
          this.service.formModel.reset();
          res.errors.forEach(element => {
            ////this.toastr.error(element.description, "Reset password failed");
            this.gnotify.showSnackBar('Reset password', element.description, "error");
          });
        }
      },
        err => {
            ////this.toastr.error(err.error.message, "Error");
            this.gnotify.showSnackBar('Reset password', err.error.message, "error");
        }
    );
  }


}
